export default __webpack_public_path__ + "a69c0945d6a67094b7fa53ed11f48aca.svg";